module.exports = __webpack_public_path__ + "img/icon_img_05.61fdb33f.png";